import { Component, OnDestroy, OnInit } from '@angular/core';
import { CoursesService } from '../../courses.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { AuthContextService } from '../../services/auth-context.service';
import { CourierService } from '../../services/courier.service';
import { TrainingService } from '../../training.service';
import { SelectCourseComponent } from 'src/app/components/select-course/select-course.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProgressService } from 'src/app/progress.service';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit, OnDestroy {


  loading = true;
  modalRef: BsModalRef;
  isLatestCourseGroup = false;
  //allCourseTypes: any[];
  ownedCourseGroups: any[] = new Array();
  preownedCourseGroups: any[] = new Array();
  unownedCourseGroups: any[] = new Array();
  defaultCourseGroups: any[] = new Array();
  relatedCourseGroups: any[] = new Array();

  rows = [];

  courseGroups: any[] = new Array();

  tags: any[] = new Array();
  selectedTags: any[] = new Array();
  showAllCourses = true;

  latestCourse: any;
  showOnlyFavorites = false;
  showing: string;
  config: any;


  constructor(
    public authContextService: AuthContextService,
    private router: Router,
    private authService: AuthService,
    private modalService: BsModalService,
    private coursesService: CoursesService,
    private trainingService: TrainingService,
    private courierService: CourierService,
    private progressService: ProgressService
  ) {
    console.log('CoursesComponent.constructor');
  }


  show($event, tag) {
    $event.preventDefault();
    this.showing = tag;
    this.showAllCourses = false;
    this.showOnlyFavorites = false;
    this.selectedTags = [tag];
  }

  showAll($event) {
    $event.preventDefault();
    this.showing = 'ALL';
    this.showOnlyFavorites = false;
    this.showAllCourses = true;
    this.selectedTags = this.tags;
  }

  showFavorites($event) {
    $event.preventDefault();
    this.showing = 'FAVORITES';
    this.showOnlyFavorites = true;
    this.showAllCourses = true;
    this.selectedTags = this.tags; //show All
  }

  ngOnInit() {
    this.trainingService.loadConfig().then(config => {
      this.config = config;
    });

    this.authService.renew().then(value => {
      this.loadCourses();
    }, error => {
      console.log('CoursesComponent.ngOnInit:error');
      this.loadCourses();
    });
  }

  openModal(courseGroup: any) {
    const initialState = {
      courseGroup: courseGroup,
      purchased: false
    };
    this.modalRef = this.modalService.show(SelectCourseComponent, { initialState, class: 'modal-lg rounded-modal' });
  }


  openCourse(course, userCourse?) {
    this.coursesService.openCourse(course, userCourse);
  }

  progressWidth(course) {
    if (course && this.latestCourse && this.latestCourse.percentageComplete) {
      const percentComplete = this.latestCourse.percentageComplete;

      if (percentComplete < 1.0) {
        return '10px';
      } else {
        return (percentComplete.toFixed(1) + '%');
      }
    }
    return '0%';
  }

  /*************  ✨ Codeium Command ⭐  *************/

  /**
   * Determines if the current user is a Young Eagles (YE) user.
   * @returns {boolean} True if the user mode is 'YE', false otherwise.
   */

  /******  98cba5a9-b697-4802-89d4-a744ddce20a2  *******/
  isYEUser(): boolean {
    return !!this.config && this.config['user.mode'] === 'YE';
  }


  //todo - move logic to be
  loadCourses() {
    const user = this.authContextService.user;

    this.loading = true;
    const initialData = {
      tags: this.tags,
      selectedTags: this.selectedTags
    };

    this.coursesService.loadCourses(initialData, user, true).then((result: any) => {
      this.tags = result.tags;
      this.selectedTags = result.selectedTags;
      this.ownedCourseGroups = result.ownedCourseGroups;
      this.preownedCourseGroups = result.preownedCourseGroups;
      this.unownedCourseGroups = result.unownedCourseGroups;
      this.defaultCourseGroups = result.defaultCourseGroups;
      this.courseGroups = result.courseGroups;
      if (result.latestCourse && result.latestCourse.name) {
        this.latestCourse = result.latestCourse;
      } else {
        this.latestCourse = this.defaultCourseGroups[0];
        this.isLatestCourseGroup = true;
      }

      this.relatedCourseGroups = result.relatedCourseGroups;
      this.loading = false;
      this.showAllCourses = true;
      this.showing = 'ALL';

      this.defaultCourseGroups.forEach(defaultCourseGroup => {
        defaultCourseGroup.isDefault = true;
        defaultCourseGroup.isOwned = false;
        if (this.ownedCourseGroups.some(ownedCourseGroup => ownedCourseGroup.id === defaultCourseGroup.id)) {
          defaultCourseGroup.isOwned = true;
        }
      });

      this.defaultCourseGroups = this.defaultCourseGroups.filter(courseGroup =>
        !this.ownedCourseGroups.some(ownedGroup => ownedGroup.id === courseGroup.id)
      );

      this.relatedCourseGroups = this.relatedCourseGroups.filter(courseGroup =>
        !this.defaultCourseGroups.some(defaultGroup => defaultGroup.id === courseGroup.id)
      );
    });
  }

  ngOnDestroy() {
    console.log('CoursesComponent.ngOnDestroy');
    this.courierService.destroy();
  }
}
